import React from 'react';
import { Breadcrumb } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/breadcrumb.less';

export default Breadcrumb;
